
import React from 'react';
import ReportSearch from '@/components/compliance/reports/ReportSearch';
import ReportTable from '@/components/compliance/reports/ReportTable';
import { ComplianceReport } from '@/components/compliance/reports/ReportTable';

interface ReportTabContentProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  filteredReports: ComplianceReport[];
  selectedTab: string;
}

const ReportTabContent: React.FC<ReportTabContentProps> = ({ 
  searchTerm, 
  onSearchChange, 
  filteredReports,
  selectedTab
}) => {
  return (
    <div className="space-y-4">
      <ReportSearch 
        searchTerm={searchTerm} 
        onSearchChange={onSearchChange} 
        placeholder={`Search ${selectedTab} reports...`}
      />
      <ReportTable 
        reports={filteredReports} 
        searchTerm={searchTerm}
      />
    </div>
  );
};

export default ReportTabContent;
